import React, { useEffect, useState } from "react";
import Select from "react-select";
import { withTranslation } from "react-i18next";
import { AllGeofenceVehicleReport } from "../../../Apis/GeofenceReports/geofenceSummaryReportApi";
import { AllVehicleDetails } from "../../../Apis/vehicleApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import Loader from "../../../Common/Loader/loader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import isGHMC, { getCurrentDateTime } from "../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../AssetVehicle/utils/helpers";
const GeofenceVehicleReportData = ({ t }) => {
  const headers = [
    "vehicleNumber",
    "geofenceName",
    "inTime",
    "outTime",
    "duration",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // New state for filtered data
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const isProd = isGHMC();
  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);

  useEffect(() => {
    fetchVehicleData();
  }, []);

  const fetchVehicleData = async () => {
    try {
      const response = await AllVehicleDetails();
      setVehicles(response);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    }
  };

  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await AllGeofenceVehicleReport(startDate, endDate);
      const formattedData = response.data.map((item) => ({
        ...item,
        geofenceName: item.geoFenceName,
      }));
      setAllTripsTonnage(formattedData); // Set all data to the state
      setIsLoading(false);
  
      // Return the formatted data for further processing
      return formattedData;
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    }
    setIsLoading(false);
  };

const handleFormSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission behavior

  try {
    // Call fetchTripsTonnageData to fetch data based on selected dates
    const data = await fetchTripsTonnageData(startDate, endDate);

    let filteredData = data; // Initialize filtered data with all trips tonnage data

    if (selectedVehicle) {
      // Filter data based on selected vehicle
      filteredData = data.filter((item) => item.vehicleNumber === selectedVehicle.value);
    }

    // Update the filteredData state with the filtered data
    setFilteredData(filteredData);
  } catch (error) {
    console.error("Error handling form submission:", error);
    // Handle error
  }
};


const handleClear = async () => {
  // Reset selected vehicle and filtered data
  setSelectedVehicle(null);
  setFilteredData([]);
  // Fetch data again with the previous start and end dates
  await fetchTripsTonnageData(getStartOfCurrentDate(), getCurrentDateTime());
};



  // const downloadAsExcel = () => {
  //   // Add serial number to each item in the collection details
  //   const dataWithSerialNumber = getAllTripsTonnage.map((item, index) => ({
  //     ...item,
  //     "s.no": index + 1,
  //   }));
  //   // Filter out only the data corresponding to the headers displayed in the table component
  //   const filteredData = dataWithSerialNumber.map((item) => ({
  //     "s.no": item["s.no"],
  //     VehicleNumber: item.vehicleNumber,
  //     GeofenceName: item.geoFenceName,
  //     Intime: item.inTime,
  //     OutTime: item.outTime,
  //     Duration: item.duration,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Geofence Vehicle Report");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  //   });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(data);
  //   downloadLink.download = "Geofence Vehicle Report.xlsx";
  //   downloadLink.click();
  // };

  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;  
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${
        currentDate.getMonth() + 1
    }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Geofence Vehicle Reports`;
    const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
   // Define styles
 const boldFont = { bold: true };

 // Add the downloadDateTime to the correct row and columns, and ensure formatting
 worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
 worksheet.mergeCells(1, 2, 1, 6); // Merge cells for downloadDateTime from column 2 to 4
 worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
 worksheet.getCell(1, 2).font = boldFont; // Set font style
 worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content
 
 // Apply styles to the merged cells (B1, C1, D1)
 for (let col = 2; col <= 6; col++) {
   worksheet.getCell(1, col).font = boldFont; // Set styles individually
   worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
 }
 
 // Add "Zone Details" to the correct row and columns, and ensure formatting
 worksheet.addRow(["", "", "Geofence Vehicle Reports", ""]); // Update array length to match new cell range
 worksheet.mergeCells(2, 2, 2, 6); // Merge cells for Zone Details from column 2 to 4
 worksheet.getCell(2, 2).value = "Geofence Vehicle Reports"; // Ensure the value is set after merging
 worksheet.getCell(2, 2).font = boldFont; // Set font style
 worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content
 
 // Apply styles to the merged cells (B2, C2, D2)
 for (let col = 2; col <= 6; col++) {
   worksheet.getCell(2, col).font = boldFont; // Set styles individually
   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
 }
 
    

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Vehicle Number",
        "Geofence Name",
        "In Time",
        "Out Time",
        "Duration",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" }; // Left align the cell content
        if (colNumber >= 1 && colNumber <=13) {
            // Apply background color only to specific cells
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" } // Red background color
            };
        }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
        worksheet.addRow([
            index + 1,
            item.vehicleNumber?? "N/A",
            item.geoFenceName?? "N/A",
            item.inTime?? "N/A",
            item.outTime?? "N/A",
            item.duration?? "N/A",
        ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 1 && colNumber <= 13) {
                // Align the columns from 1 to 4 to the left
                cell.alignment = { horizontal: "left" };
            } else {
                // Align the rest of the columns to the center
                cell.alignment = { horizontal: "center" };
            }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
        { width: 5 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "GeofenceVehicleReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
};

const calculateGVPTotals = (data) => {
  const totals = {
    sno: 'Total',
    siteName: 'Total',
    vehicleInCount: 0,
    vehicleOutCount: 0,
  };

  data.forEach(row => {
      totals.vehicleInCount += row.vehicleInCount || 0;
      totals.vehicleOutCount += row.vehicleOutCount || 0;
  });
  return totals;
};

const totalZoneRow = calculateGVPTotals(getAllTripsTonnage);
const GVPDataWithTotal = [...getAllTripsTonnage, totalZoneRow];
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
            <h4 class="text-start mb-3"> {t("Geofence Vehicle Report")} </h4>
              <div className="card">
                <div className="card-body p-3">
                <div className="row align-items-end">
                  <div className="col-md-10">
                  <form onSubmit={handleFormSubmit}>
                    <div className="row align-items-end" style={{textAlign:'left'}} >
                      <div className="col-md-3">
                        <label>From Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="FromDate"
                          style={inputStyle}
                          value={startDate}
                          className="form-control"
                          min={getOneMonthPastDateTime()}
                          max={getNowDateTime()}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>To Date & Time:</label>
                        <input
                          min={startDate}
                          type="datetime-local"
                          name="ToDate"
                          style={inputStyle}
                          value={endDate}
                          className="form-control"
                          max={getCurrentDateTime()}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Select Vehicle</label>
                        <Select
                          classNamePrefix="CreatableSelect"
                          value={selectedVehicle}
                          onChange={(selectedOption) =>
                            setSelectedVehicle(selectedOption)
                          }
                          options={Array.from(
                            new Set(
                              getAllTripsTonnage.map(
                                (vehicle) => vehicle.vehicleNumber
                              )
                            )
                          ).map((vehicleNumber) => ({
                            value: vehicleNumber,
                            label: vehicleNumber,
                          }))}
                          placeholder="Select Vehicle"
                          backspaceRemovesValue
                          isSearchable
                          isClearable
                        />
                      </div>
                      <div className="col-md-3">
                      <div className="d-flex justify-content-start align-items-end">
                        <button
                         type="submit" 
                        className={`btn  ${isProd ? "search-ghmc" : "search-swm"}`}>
                          Search
                        </button>
                        <button
                          type="button"
                          className={`btn ms-3 ${isProd ? "search-ghmc" : "search-swm"}`}
                          onClick={handleClear}
                          
                        >
                          Clear
                        </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-excel ms-auto"
                      onClick={downloadAsExcel}
                    >
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
               
                 
                


                  <div className="mt-3">
                    <TableComponent
                      DataFetchURL={
                        filteredData?.length > 0
                          ? filteredData
                          : GVPDataWithTotal
                      }
                      headers={headers}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withTranslation()(GeofenceVehicleReportData);

const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  borderRadius: "5px",
  color: "#fff",
};

const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

